import { useContext } from "react";
import { AuthContext, type AuthState } from "../AuthProvider";

export const useAuth = (): AuthState => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error(`must be used within a AccountsProvider`);
  return ctx;
};
